import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для отображения информации о zIndex выбранных элементов
 */
export const ZIndexDisplay = ({ selectedElements }) => {
    var _a;
    if (selectedElements.length === 0)
        return null;
    let zIndex = '';
    if (selectedElements.length === 1) {
        zIndex = ((_a = selectedElements[0].zIndex) !== null && _a !== void 0 ? _a : 0).toString();
    }
    else {
        // Если выбрано несколько элементов, показываем диапазон
        const zIndexes = selectedElements.map((el) => { var _a; return (_a = el.zIndex) !== null && _a !== void 0 ? _a : 0; });
        const minZIndex = Math.min(...zIndexes);
        const maxZIndex = Math.max(...zIndexes);
        zIndex = `${minZIndex} - ${maxZIndex}`;
    }
    return (_jsx("div", { style: {
            padding: '0px 6px',
            fontSize: '0.8rem',
            color: '#444',
        }, children: _jsxs("span", { children: ["z-Index: ", zIndex] }) }));
};
